import Header from '../../components/Header/Header';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(Header);
